import { InMemoryCacheConfig } from '@apollo/client'

export const inMemoryCacheConfig: InMemoryCacheConfig = {}
